export const tillhubApp = {
  id: 97,
  name: "tillhub",
  label: "Tillhub",
  // No credentials check on purpose. Tillhub has three login variants - API key,
  // organisation, e-mail - and a customer fills exactly one of them. The backend
  // registry (Modules\SalesChannel\Support\ConnectionTest\ConnectionTestRecipes)
  // can express the API-key variant, because {{id}} and {{key}} are credential
  // placeholders the prober substitutes and they match this app's field names.
  // It cannot express the other two: there is no {{username}}/{{password}}
  // placeholder, and Tillhub expects those in a JSON body rather than as basic
  // auth. A test that only passes for API-key users would block everyone else at
  // the wizard gate, which is worse than no test at all. See CONNECT-6787.
  showTestConnection: false,
  logo: process.env.BASE_URL + "media/shopLogos/tillhub.svg",
  // Reporting is not planned for Tillhub. "migration" is the initial data import
  // (products from the shop into Connect) - Tillhub has no such flow, so the area
  // stays hidden (CONNECT-7085, same as Kaufland in CONNECT-6983). The shopimporter
  // takeover ("Integration übernehmen") is a different feature: it is gated on
  // shopImporterWorkflowId below and works without this area.
  areaBlacklist: ["migration", "reporting"],
  environmentVariables: {
    presetId: process.env?.VUE_APP_SCM_APP_TILLHUB_PRESET_ID,
    testWorkflows: {
      product: process.env?.VUE_APP_SCM_APP_TEST_PRODUCT_WORKFLOW_ID,
      salesOrder: process.env?.VUE_APP_SCM_APP_TILLHUB_TEST_ORDER_WORKFLOW_ID,
      stock: process.env?.VUE_APP_SCM_APP_TEST_STOCK_WORKFLOW_ID,
      prices: process.env?.VUE_APP_SCM_APP_TEST_PRICES_WORKFLOW_ID
    },
    testBatchWorkflows: {
      salesOrder:
        process.env?.VUE_APP_SCM_APP_TILLHUB_TEST_BATCH_ORDER_WORKFLOW_ID
    },
    shopImporterWorkflowId:
      process.env?.VUE_APP_SCM_APP_TILLHUB_MIGRATION_SHOPIMPORTER_WORKFLOW_ID
  }
};
